window.global ||= window;

// Must stay the first imports: strip `?authToken=` and `?username=&password=`
// before anything reads the URL.
import "src/utils/authTokenFromUrl";
import "src/utils/credentialsFromUrl";
import { patchDomForExtensions } from "src/utils/patchDomForExtensions";
patchDomForExtensions();

import { createRoot } from "react-dom/client";

// CSS
// import "antd/dist/antd.css";

import "#css/globals.css";

// Sentry
import * as Sentry from "@sentry/react";
import { extraErrorDataIntegration } from "@sentry/integrations";

import App from "#app/app";
import config from "#config";
import "#app/genericErrorHandler";
import { beforeSend } from "src/utils/beforeSend";
import { unregister } from "src/serviceWorker";
import { loadIntercom } from "src/utils/intercomSnippet";
import { signinPreload } from "src/utils/signinPreload";
import { initI18n } from "#i18n/utils";

if (config.env === "production") {
    Sentry.init({
        dsn: config.SENTRY_DSN,
        release: config.releaseVersion,
        normalizeDepth: 10,
        integrations: [extraErrorDataIntegration({ depth: 10 })],
        beforeSend,
    });
}

// Unregister servicerWorker to bust browser cache on new builds
unregister();
loadIntercom();
initI18n();

async function bootstrap() {
    const container = document.getElementById("root");
    if (container) {
        const root = createRoot(container);
        signinPreload();
        root.render(<App />);
    }
}

bootstrap();
